let apiSubdomain = `https://stage-api.`;
if(process.env.NODE_ENV === 'development')
  apiSubdomain = `https://stage-api.`;

export const COGNITO_USER_POOL_CLIENT_ID = "2fs2geiekfaonh5thfhsfvstdm";

export const DIGMS_API_BASE_URL = process.env.REACT_APP_DIGMS_API_BASE_URL; // Set in Jenkinsfile or .env
export const DS_BASE_URL = apiSubdomain + DIGMS_API_BASE_URL; 

// Authentication
export const APP_BASE_URL = process.env.REACT_APP_BASE_URL; // PROD URL set in .env
// export const APP_BASE_URL = 'https://stage.sem-internal-tools.digmstools.com'; // STAGE URL
export const APP_BASE_URL_DEV = "http://localhost:3000" // DEV URL